import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-35">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-36">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-37">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-38">
              <h3 className="text-xl font-bold text-brand-brown font-serif" data-id="element-39">
                {title}
              </h3>
              <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-40">
                <XIcon className="w-5 h-5 text-brand-gray" data-id="element-41" />
              </button>
            </div>
            <div className="px-6 py-6 text-brand-gray text-base leading-relaxed space-y-4" data-id="element-42">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function FooterSection() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-brand-brown text-brand-cream/60 py-8 px-4 text-center text-sm" data-id="element-43">
        <div className="max-w-2xl mx-auto" data-id="element-44">
          <div className="flex items-center justify-center gap-6 mb-4" data-id="element-45">
            <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 hover:text-brand-cream transition-colors" data-id="element-46">
              Política de Privacidad
            </button>
            <span className="text-brand-cream/30" data-id="element-47">|</span>
            <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 hover:text-brand-cream transition-colors" data-id="element-48">
              Términos y Condiciones
            </button>
          </div>
          <p className="mb-2" data-id="element-49">
            © {new Date().getFullYear()} Rutinas de Conexión Express. Todos los
            derechos reservados.
          </p>
          <p data-id="element-50">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-51">
        <p data-id="element-52">
          <strong data-id="element-53">Última actualización:</strong> abril 2026
        </p>
        <p data-id="element-54">
          En Rutinas de Conexión Express nos comprometemos a proteger tu
          privacidad. Esta política describe cómo recopilamos, usamos y
          protegemos tu información personal.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-55">
          1. Datos que recopilamos
        </h4>
        <p data-id="element-56">
          Al realizar tu compra, recopilamos tu nombre, dirección de correo
          electrónico y datos de pago necesarios para procesar la transacción.
          No almacenamos datos de tarjetas de crédito en nuestros servidores.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-57">
          2. Uso de los datos
        </h4>
        <p data-id="element-58">
          Utilizamos tus datos exclusivamente para enviarte el producto digital
          adquirido y, si lo autorizas, comunicaciones relacionadas con
          contenido de valor para padres.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-59">
          3. Protección de datos
        </h4>
        <p data-id="element-60">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal conforme al Reglamento General de
          Protección de Datos (RGPD) de la Unión Europea.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-61">
          4. Tus derechos
        </h4>
        <p data-id="element-62">
          Tienes derecho a acceder, rectificar, suprimir y portar tus datos
          personales. También puedes oponerte al tratamiento o solicitar su
          limitación en cualquier momento.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-63">5. Cookies</h4>
        <p data-id="element-64">
          Este sitio puede utilizar cookies técnicas y analíticas para mejorar
          tu experiencia de navegación. Puedes configurar tu navegador para
          rechazarlas.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-65">
        <p data-id="element-66">
          <strong data-id="element-67">Última actualización:</strong> abril 2026
        </p>
        <p data-id="element-68">
          Al adquirir el producto "Rutinas de Conexión Express", aceptas los
          siguientes términos y condiciones de uso.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-69">
          1. Producto digital
        </h4>
        <p data-id="element-70">
          El producto consiste en un manual en formato PDF descargable. El
          acceso se proporciona de forma inmediata tras la confirmación del
          pago.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-71">
          2. Uso personal
        </h4>
        <p data-id="element-72">
          El contenido adquirido es para uso personal y no puede ser
          reproducido, distribuido ni revendido sin autorización expresa por
          escrito.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-73">
          3. Política de reembolso
        </h4>
        <p data-id="element-74">
          Dado que se trata de un producto digital de acceso inmediato, no se
          ofrecen reembolsos una vez completada la descarga, salvo en casos
          excepcionales evaluados individualmente.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-75">
          4. Limitación de responsabilidad
        </h4>
        <p data-id="element-76">
          El contenido del manual tiene carácter informativo y educativo. No
          sustituye el asesoramiento profesional psicológico, legal o médico.
          Los resultados pueden variar según cada situación familiar.
        </p>
        <h4 className="font-bold text-brand-brown text-lg mt-2" data-id="element-77">
          5. Legislación aplicable
        </h4>
        <p data-id="element-78">
          Estos términos se rigen por la legislación española. Cualquier
          controversia será sometida a los juzgados y tribunales competentes en
          España.
        </p>
      </Modal>
    </>;
}